module.exports = __webpack_public_path__ + "cb314c1876f4d5d8b3fa48762412b7a6.glb";